import React, { useEffect, useState } from 'react';

const VerticalDatePicker = ({ onDateSelect = () => {} }) => {
  const [dates, setDates] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(1);

 

  useEffect(() => {
  const today = new Date();
  const tempDates = [];

  for (let i = 0; i < 365; i++) {
    const date = new Date(today);
    date.setDate(today.getDate() + i);
    tempDates.push(date);
  }

  setDates(tempDates);
  setSelectedIndex(0); 
  onDateSelect(tempDates[0]);
}, []);


  const formatDate = (date) => ({
    day: date.getDate(),
    month: date.toLocaleString('default', { month: 'long' }),
    year: date.getFullYear(),
  });

  return (
    <div className="vertical-date-wrapper">
      {dates.map((date, index) => {
        const { day, month, year } = formatDate(date);
        const isSelected = index === selectedIndex;

        return (
          <div
            key={index}
            className={`date-item ${isSelected ? 'selected' : ''}`}
            onClick={() => {
              setSelectedIndex(index);
              onDateSelect(date);
            }}
          >
            <span>{day}</span>
            <span>{month}</span>
            {isSelected && <span>{year}</span>}
          </div>
        );
      })}
    </div>
  );
};

export default VerticalDatePicker;